import SocialInitiativeDetail from "@components/pages/our-commitment/detail/social-initiative-detail"
import { getPostBySlug, getPageBySlug } from "lib/api"

function SocialInitiativeDetailPage({ data, locale }) {
  return (
    <>
      <SocialInitiativeDetail data={data} locale={locale} />
    </>
  )
}
export default SocialInitiativeDetailPage

export async function getServerSideProps(ctx) {
  ctx.res.setHeader(
    "Cache-Control",
    "public, s-maxage=43200, stale-while-revalidate=60"
  )
  const { locale } = ctx
  const { slug } = ctx.query
  try {
    const data = await getPostBySlug(slug)
    return {
      props: {
        seo: {
          title: data[`title_${locale}`] || "Newsroom",
        },
        page: "social-initiative-detail",
        theme: "white",
        data,
        locale,
      },
    }
  } catch (error) {
    return { notFound: true }
  }
}
